<script>
    import ContactLeadForm from "../components/ContactLeadForm.svelte";
</script>

<section class="aux-page aux-contact">
    <div class="aux-head">
        <p class="aux-eyebrow">Contact</p>
        <h1>Contact Us</h1>
        <p>
            Reach out directly or send us a message and our team will follow up
            quickly.
        </p>
    </div>

    <div class="aux-grid two">
        <article class="aux-panel">
            <h2>Office Details</h2>
            <address class="contact-address">
                <p>3700 Portage Avenue</p>
                <p>Winnipeg, Manitoba</p>
                <p>
                    <strong>Email:</strong>
                    <a href="mailto:vgoauto@gmail.com">vgoauto@gmail.com</a>
                </p>
                <p>
                    <strong>Tel:</strong>
                    <a href="tel:+12042966886">204-296-6886</a>
                </p>
                <p><strong>Fax:</strong> 204-421-4231</p>
            </address>
        </article>

        <article class="aux-panel">
            <ContactLeadForm
                heading="Send A Message"
                intro="Share a few details and we will help with financing options or vehicle sourcing."
                submitLabel="Send Inquiry"
            />
        </article>
    </div>
</section>
